import { withABNFormat } from '../../hoc';
import { PatternField } from '../PatternField';

export const TextFieldWithABNPattern = withABNFormat(PatternField);
